import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import tocActions from '../../actions/TocActions';
import questionSelectionService from '../../services/QuestionSelectionService';
import responseReader from '../../store/readHelpers/ResponseReader';

const { filterTypes } = tocActions;

class TOCFilterItem extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        ariaControl: PropTypes.string.isRequired,
        ariaSelected: PropTypes.bool.isRequired,
        filterName: PropTypes.string.isRequired,
        dispatch: PropTypes.func.isRequired,
        toc: PropTypes.object,
        flaggedItems: PropTypes.array,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(tocActions.setFilter(filterTypes.ALL));
    }

    setFilter = () => {
        const { dispatch, filterName } = this.props;
        dispatch(tocActions.setFilter(filterName));
    };

    getFilterHits = () => {
        const { filterName, toc, flaggedItems } = this.props;

        switch (filterName) {
        case tocActions.filterTypes.ALL:
            return toc.numberOfQuestions;
        case tocActions.filterTypes.NOT_ATTEMPTED:
            return toc.numberOfQuestions - responseReader.getTotalNumberOfResponses();
        case tocActions.filterTypes.FLAGGED:
            return flaggedItems.length;
        case tocActions.filterTypes.MANUALLY_SELECTED:
            return questionSelectionService.getAllSelectedQuestions().length;
        case tocActions.filterTypes.MANUALLY_SELECTED_NOT_ATTEMPTED:
            return questionSelectionService.getSelectedButNotAttemptedQuestions().length;
        default:
            return 0;
        }
    };

    render() {
        const { id, toc, filterName, ariaControl, ariaSelected } = this.props;
        const isActive = filterName === toc.filter ? 'active' : null;

        return (
            <button
                id={id}
                aria-controls={ariaControl}
                aria-selected={ariaSelected}
                className={isActive}
                onClick={this.setFilter}
                role="tab"
            >
                {t(`testOverview.filterTab.${filterName}`)} ({this.getFilterHits()})
            </button>
        );
    }
}

function mapStateToProps(state) {
    const { toc, itemFlag: { flaggedItems } } = state;
    return {
        toc,
        flaggedItems,
    };
}

const TOCFilterItemContainer = connect(mapStateToProps)(TOCFilterItem);

export default TOCFilterItemContainer;
